export const goToIndex = (newIndex, animating, setActiveIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
};

export const next = (resources, activeIndex, setActiveIndex, animating, setCarouselSubscription) => {
    const nextIndex = activeIndex === resources.length - 1 ? 0 : activeIndex + 1;
    goToIndex(nextIndex, animating, setActiveIndex);
    if (setCarouselSubscription !== undefined)
        setCarouselSubscription(resources[nextIndex].offerName)
};

export const previous = (resources, activeIndex, setActiveIndex, animating, setCarouselSubscription) => {
    const prevIndex = activeIndex === 0 ? resources.length - 1 : activeIndex - 1;
    goToIndex(prevIndex, animating, setActiveIndex);
    if (setCarouselSubscription !== undefined)
        setCarouselSubscription(resources[prevIndex].offerName)
};